import Token from '~/api/Token';
import axios from 'axios';
import AuthService from '~/services/AuthService';
import router from '~/router';
import URLS from '~/URLS';

const tokenEndpoint = `${process.env.VUE_APP_IDENTITY_SERVER_API_URL}api/v1/identity/token/refresh`;

let axiosRequestInterceptor = null;

function createAxiosRequestInterceptor() {
    if (axiosRequestInterceptor) {
        return;
    }

    axiosRequestInterceptor = axios.interceptors.request.use(request => {
        const token = Token.getAccess();

        request.headers.Authorization = !!token ? `Bearer ${token}` : undefined;

        return request;
    }, console.error);
}
createAxiosRequestInterceptor();

// This is an axios-interceptor that asks for a new access token if a response
// returns a 401. This requires that there also is an refresh-token available.
let responseInterceptorCreated = false;
let refreshTokenRequest = null;
const createAxiosResponseInterceptor = () => {
    if (responseInterceptorCreated) {
        return;
    }
    responseInterceptorCreated = true;

    const interceptor = axios.interceptors.response.use(
        response => response,
        error => {
            const response = error.response;
            if (!response) {
                return Promise.reject(error);
            }

            // Reject promise if usual error
            if (response.status !== 401 && response.status !== 403) {
                return Promise.reject(error);
            }

            if (!AuthService.isLoggedIn()) {
                return Promise.reject(error);
            }

            if (!shouldRefreshToken()) {
                return Promise.reject(error);
            }

            // Make sure axios does not loop if incoming request also returns 401
            axios.interceptors.response.eject(interceptor);

            if (refreshTokenRequest) {
                // An existing refresh-token request is already running.
                return refreshTokenRequest.then(() => axios(error.response.config));
            }

            refreshTokenRequest = getAccessByRefresh()
                .then((/* data */) => {
                    // If successfully recieved new token, execute the failed request again with the new token.
                    error.response.config.headers['Authorization'] = 'Bearer ' + Token.getAccess();
                    return axios(error.response.config);
                })
                .catch(error => {
                    // If not able to recieve new access token, log the user out.
                    AuthService.logOut();
                    router.push(URLS.findjobs);
                    return error;
                })
                .finally(() => {
                    refreshTokenRequest = null;
                    createAxiosResponseInterceptor();
                });
            return refreshTokenRequest;
        }
    );
};

// If there is not an access token, but there is an refresh token
export const shouldRefreshToken = () => {
    if (Token.getAccess()) {
        return false;
    }

    return Boolean(Token.getRefresh());
};

// Gets an access token from identity-server by existing refresh-token
export const getAccessByRefresh = async () => {
    // Get refresh token
    const refreshToken = Token.getRefresh();
    if (!refreshToken) {
        return Promise.reject();
    }

    // Get new access token with refresh token
    return axios({
        method: 'POST',
        url: tokenEndpoint,
        data: {
            refreshToken,
        },
    }).then(data => {
        const response = data.data || {};
        const newAccessToken = response.accessToken;
        const newRefreshToken = response.refreshToken;

        if (newAccessToken) {
            Token.setAccess(newAccessToken);
        }
        if (newRefreshToken) {
            Token.setRefresh(newRefreshToken);
        }
        return response;
    });
};

// Initialize axios-refresh-token interceptor
createAxiosResponseInterceptor();

// Get new access-token if there is an available refresh-token

if (shouldRefreshToken()) {
    getAccessByRefresh()
        .then((/* data */) => {
            AuthService.loadUserData();
            AuthService.setIsLoggedIn(true);
        })
        .catch((/* err */) => {
            removeUserInfo();
        });
} else {
    removeUserInfo();
}

// refreshToken();
setInterval(refreshToken, 14 * 60 * 1000); // Every 14th minute. (token lives for 15)

function refreshToken() {
    getAccessByRefresh()
        .then((/* data */) => {
            AuthService.loadUserData();
            AuthService.setIsLoggedIn(true);
        })
        .catch((/* err */) => {
            removeUserInfo();
        });
}

function removeUserInfo() {
    let temp = localStorage.getItem('vuex');
    if (temp) {
        let temp2 = JSON.parse(temp);
        if (temp2) {
            delete temp2.user;
            localStorage.setItem('vuex', JSON.stringify(temp2));
        }
    }
}
